import { render, staticRenderFns } from "./backproject1.vue?vue&type=template&id=2a1377d5&scoped=true&"
import script from "./backproject1.vue?vue&type=script&lang=js&"
export * from "./backproject1.vue?vue&type=script&lang=js&"
import style0 from "./backproject1.vue?vue&type=style&index=0&id=2a1377d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1377d5",
  null
  
)

export default component.exports